// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"77b297eb","156":"0c3b3612","303":"a2d0e542","668":"039e5c23","742":"a3047982"}[chunkId] + ".chunk.js";
};